import { GridColDef } from '@mui/x-data-grid';
import { IAutomatedEmailCampaignListPayload } from 'wisestep-api';
import { FieldOption, WsTypography } from 'wisestep-base';

import { IBreadCrumbsList } from '../../../components/WsBreadCrumbs';
import { RouteOptions } from '../../../features/candidateLayout/utils/helper';
import { getBreadCrumbWithLabel } from '../../users/helper/defaultValues';

const baseCrumbs = {
  JOBS: [{ label: 'Jobs', url: '/jobs' }],
};

export type IJobEmailCamapaignBreadCrumbTypes = keyof typeof baseCrumbs | 'CAMPAIGN_EMAILS';

export const JobEmailCamapignBreadCrumbs: Record<
  IJobEmailCamapaignBreadCrumbTypes,
  IBreadCrumbsList[]
> = {
  ...baseCrumbs,
  CAMPAIGN_EMAILS: [...baseCrumbs.JOBS, { label: 'Email Campaigns', url: '/jobs/email-campaigns' }],
};

export const getJobEmailCampaignBreadCrumbsList = (label: string): IBreadCrumbsList[] => [
  ...JobEmailCamapignBreadCrumbs.CAMPAIGN_EMAILS,
  getBreadCrumbWithLabel(label),
];

export enum IJobCampaignEmailTabTypes {
  ANALYTICS = 'Analytics',
  RESPONSE = 'Response',
  SENT = 'Sent',
}

export const jobCampaignEmailTabs = [
  {
    tabName: IJobCampaignEmailTabTypes.ANALYTICS,
  },
  {
    tabName: IJobCampaignEmailTabTypes.RESPONSE,
  },
  {
    tabName: IJobCampaignEmailTabTypes.SENT,
  },
];

export const getDefaultTab = (type: IJobCampaignEmailTabTypes) => {
  const index = jobCampaignEmailTabs.findIndex((tab) => tab.tabName === type);
  return index !== -1 ? index : 2;
};

export const stripHtmlUsingRegex = (html: string): string =>
  html
    ?.replace(/<[^>]*>/g, '')
    ?.replace(/\s+/g, ' ')
    ?.trim() ?? '';

export const getCampaignAnalyticsColumns = (): GridColDef[] => [
  {
    field: 'delivery_status',
    headerName: 'Matric',
    minWidth: 160,
    flex: 2,
    renderCell: (params) => <WsTypography>{params.value}</WsTypography>,
  },
];

export const getJobEmailCampaigntPayload = (
  jobId: string,
  campaignCode: string,
  direction: 'OUT_BOUND' | 'IN_BOUND'
): IAutomatedEmailCampaignListPayload => {
  return {
    page: 0,
    size: 20,
    search: '',
    jobId: jobId,
    campaignCode: campaignCode,
    workspaceId: '',
    sortField: '',
    direction: direction,
  };
};

export const getJobEmailCampaignAnalyticsPayload = (
  jobId: string,
  campaignCode: string
): IAutomatedEmailCampaignListPayload => {
  return {
    jobId: jobId,
    campaignCode: campaignCode,
  } as IAutomatedEmailCampaignListPayload;
};

export const getRedirectionUrl = (candidateId: string, type: RouteOptions): string =>
  `/candidate-layout/${type}?id=${candidateId}&array=${[candidateId]}`;

export const defaultColumnSettings = (): FieldOption[] => [
  { id: 'job', checked: true, required: true },
  { id: 'campaigncode', checked: true },
  { id: 'sent', checked: true },
  { id: 'response', checked: true },
  { id: 'createdOn', checked: true },
  { id: 'status', checked: true },
];

export enum IJobCampaignEmailAnalyticsTabs {
  SENT = 'Sent',
  DELIVERED = 'Delivered',
  BOUNCED = 'Bounced',
  OPENED = 'Opened',
}

type jobCampaignEmailAnalyticsTab = {
  tabName: IJobCampaignEmailAnalyticsTabs;
};

export const jobCampaignEmailAnalyticsTabs: jobCampaignEmailAnalyticsTab[] = [
  {
    tabName: IJobCampaignEmailAnalyticsTabs.SENT,
  },
  {
    tabName: IJobCampaignEmailAnalyticsTabs.DELIVERED,
  },
  {
    tabName: IJobCampaignEmailAnalyticsTabs.BOUNCED,
  },
  {
    tabName: IJobCampaignEmailAnalyticsTabs.OPENED,
  },
];
